import { useState, useMemo } from 'react';
import { useNotifications } from '../context/NotificationContext';
import './NotificationHistory.css';

function NotificationHistory() {
  const { notifications, markAsRead, clearAll } = useNotifications();
  const [filter, setFilter] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');

  const filtered = notifications.filter((n) => {
    if (filter === 'unread' && n.read) return false;
    if (filter === 'read' && !n.read) return false;
    if (searchQuery && !n.message.toLowerCase().includes(searchQuery.toLowerCase())) {
      return false;
    }
    return true;
  });

  const groupedByDate = useMemo(() => {
    const groups = {};

    filtered.forEach(notification => {
      const date = new Date(notification.timestamp);
      const dateKey = date.toLocaleDateString('mk-MK', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });

      if (!groups[dateKey]) {
        groups[dateKey] = [];
      }
      groups[dateKey].push(notification);
    });

    return groups;
  }, [filtered]);

  return (
    <div className="notification-history">
      <div className="history-header">
        <h2>Историја на нотификации</h2>
        <div className="history-controls">
          <input
            type="text"
            placeholder="Пребарај..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="search-input"
          />
          <select value={filter} onChange={(e) => setFilter(e.target.value)}>
            <option value="all">Сите</option>
            <option value="unread">Непрочитани</option>
            <option value="read">Прочитани</option>
          </select>
          <button className="button button-outline" onClick={clearAll}>
            Избриши сите
          </button>
        </div>
      </div>

      <div className="notifications-list">
        {Object.keys(groupedByDate).length === 0 ? (
          <div className="empty-state">Нема нотификации</div>
        ) : (
          Object.entries(groupedByDate).map(([date, notifs]) => (
            <div key={date} className="notification-group">
              <div className="group-date-header">{date}</div>
              {notifs.map((notification) => (
                <div
                  key={notification.id}
                  className={`notification-item ${notification.read ? 'read' : 'unread'}`}
                  onClick={() => !notification.read && markAsRead(notification.id)}
                >
                  <div className="notification-icon">
                    {notification.type === 'alert' ? '🔔' : '📧'}
                  </div>
                  <div className="notification-content">
                    <div className="notification-message">{notification.message}</div>
                    <div className="notification-meta">
                      {notification.crypto && (
                        <span className="notification-crypto">{notification.crypto}</span>
                      )}
                      {notification.price && (
                        <span className="notification-price">${notification.price.toLocaleString()}</span>
                      )}
                      <span className="notification-time">
                        {new Date(notification.timestamp).toLocaleTimeString('mk-MK', {
                          hour: '2-digit',
                          minute: '2-digit'
                        })}
                      </span>
                    </div>
                  </div>
                  {!notification.read && <div className="unread-badge" />}
                </div>
              ))}
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default NotificationHistory;
